var hasWeakMap = typeof WeakMap !== 'undefined'

export function walk (object, schema, fn) {
    function walk (fn, value, schema, object, property, path) {
      if (schema instanceof Array) {
        value = value || []
        value.forEach((item, n) =>
          walk(fn, item, schema[0], value, n, path + '[' + n + ']')
        )
      } else if (typeof schema === 'function') {
        return fn(value, schema, object, property, path, function (subSchema) {
          walk(fn, value, subSchema, object, property, path)
        })
      } else if (typeof schema === 'object') {
        value = value || {}
        Object.keys(schema).forEach(key => {
          walk(fn, value[key], schema[key], value, key, path + '.' + key)
        })
      }
    }

    return walk(fn, object, schema, undefined, undefined, 'model', undefined)
  }

export function validate (object, schema, results = new ValidationResult()) {

    const is = (value, test, object, property, path, subWalk) => {
      let errors = 0

      function setError (error) {
        if (!errors) {
          results.setError({
            value: value,
            object: object,
            property: property,
            error: error,
            path: path,
          })

          if (error) {
            errors++
          }
        }
      }

      function subTest (subSchema) {
        var errorsBefore

        if (typeof subSchema === 'function') {
          errorsBefore = errors
          var error = subSchema(value, subTest, object, property, path)
          setError(error)
          return errorsBefore == errors
        } else {
          errorsBefore = results.errors.length
          subWalk(subSchema)
          return errorsBefore == results.errors.length
        }
      }

      setError(test(value, subTest, object, property, path))
    }

    function subValidate (object, schema) {
      walk(
        object,
        schema,
        is
      )
    }

    subValidate(object, schema)

    return results
  }

export function inObjectValidationObject (object) {
    var validationErrors = object._validationErrors

    if (!validationErrors) {
      validationErrors = {}
      Object.defineProperty(object, '_validationErrors', {
        value: validationErrors,
      })
    }

    return validationErrors
  }

export function weakMapValidationObject (object, map) {
    var validationObject = map.get(object)

    if (!validationObject) {
      validationObject = {}
      map.set(object, validationObject)
    }

    return validationObject
  }

export function fieldVisited (object, schema, model, property) {
    var validation = validate(object, schema)

    model._visited = model._visited || []
    if (model._visited.indexOf(property) === -1) {
      model._visited.push(property)
    }

    return validation
  }


function ValidationResult () {
  this.valid = true
  this.errors = []
  this.errorMap = hasWeakMap ? new WeakMap() : undefined
}

ValidationResult.prototype.error = function (object, property) {
  return validationObject(object, this.errorMap)[property]
}

ValidationResult.prototype.setError = function (error) {
  var validationErrors = validationObject(error.object, this.errorMap)

  validationErrors[error.property] = error.error

  if (error.error) {
    this.valid = false
    this.errors.push({
      value: error.value,
      object: error.object,
      property: error.property,
      error: error.error,
      path: error.path,
    })
  }
}

export const validationObject = hasWeakMap
  ? weakMapValidationObject
  : inObjectValidationObject